import { render, staticRenderFns } from "./HistoryAccessControl.vue?vue&type=template&id=50a608f4&scoped=true"
import script from "./HistoryAccessControl.vue?vue&type=script&lang=js"
export * from "./HistoryAccessControl.vue?vue&type=script&lang=js"
import style0 from "./HistoryAccessControl.vue?vue&type=style&index=0&id=50a608f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a608f4",
  null
  
)

export default component.exports